export { DefaultHero, DefaultHero as default } from "./DefaultHero";
